import { environment } from "@sharedenvironment";

export class SampleApiUrlUtil {
  /**
   * Format the API url route to send it to the Sample micro service
   * @param apiRoute the api route without the extension
   * @returns the API route with the needed extension
   */
  public static formatApiUrl(apiRoute: string): string {
    return environment.sample.baseUrl + apiRoute;
  }
}